


















import AppFooter from '@/components/AppFooter.vue';
import AppNavbar from '@/components/AppNavbar.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: { AppNavbar, AppFooter }
})
export default class SiteWrapper extends Vue {
  @Prop({ default: false })
  public readonly isPadless!: boolean;

  @Prop({ default: false })
  public readonly disableFooter!: boolean;

  @Prop({ default: 'JBI' })
  public readonly title!: string;

  @Prop({ default: 'JBI' })
  public readonly description!: string;
}
